import {appSyncConnectionApi} from '../appSyncConnectionApi';
import {clearReauthAttempts} from './clearReauthAttempts';
import type {SubscriptionDeps, SubscriptionState} from './subscriptionTypes';

export const handleSubscriptionAck = (state: SubscriptionState, deps: SubscriptionDeps) => {
  clearReauthAttempts(state);

  if (state.hasConnected) {
    deps.dispatch(
      appSyncConnectionApi.util.updateQueryData('getAppSyncConnection', undefined, (draft) => {
        draft.reconnectCount += 1;
      })
    );
    return;
  }

  state.hasConnected = true;
};
